import { configureRequestParams, getErrorMessage } from '@/utils/helpers'

import axios from './instance'

/**
 * Gets the list of trainings.
 */
export const getTrainings = async (
  { sorting, pagination, searchTerm, fullList } = { fullList: false },
) => {
  let params = ''
  if (fullList) {
    params = '?limit=1000'
  } else {
    params = configureRequestParams(sorting, pagination, searchTerm)
  }
  try {
    return await axios.get(`/trainings/${params}`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Add a new training.
 * @param {object} payload - The training data to be added.
 */
export const addTraining = async (payload) => {
  try {
    return await axios.post('/trainings/', payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Update an training.
 * @param {object} payload - The training data to be updated.
 */
export const updateTraining = async (payload) => {
  try {
    return await axios.patch(`/trainings/${payload.id}/`, payload)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}

/**
 * Deletes an training.
 * @param {string} id - The training id to be deleted.
 */
export const deleteTraining = async (id) => {
  try {
    return await axios.delete(`/trainings/${id}/`)
  } catch (err) {
    throw new Error(getErrorMessage(err))
  }
}
